import * as actions from './actions'
import { success, failure } from 'utilities/actions'

export type State = {
  data: any;
  errors: any[];
};

type Action = {
  type: string;
  data?: any;
  errors?: any[];
};

const initialState = {
  data: {},
  errors: []
} as const

const reducer = (state: State, action: Action) => {
// @ts-expect-error - TS2322 - Type '{ readonly data: {}; readonly errors: readonly []; }' is not assignable to type 'State'.
  if (state === undefined) { state = initialState }
  switch (action.type) {
    case success(actions.API_SIGNUPS_CREATE):
      return { ...state, data: action.data }
    case failure(actions.API_SIGNUPS_CREATE):
      return { ...state, errors: action.errors }
    default:
      return state
  }
}

export default reducer
